import { jsxs, jsx } from "react/jsx-runtime";
import { toolProductToSectionProduct, sectionFadeInStyle } from "./utils.js";
import { ProductGroupCarousel } from "../../ProductGroupCarousel.js";
function DataProductCarouselsPart({
  part
}) {
  const section = part.data;
  if (!section || !section.products || section.products.length === 0) return null;
  const products = section.products.map(toolProductToSectionProduct);
  const sectionSkus = section.products.map((p) => p.stacklineSku).filter(Boolean);
  if (products.length === 0) return null;
  return /* @__PURE__ */ jsxs("div", { className: "concierge-product-sections", children: [
    /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: sectionFadeInStyle } }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "concierge-section",
        style: { animation: "concierge-fade-in 0.35s ease-out both" },
        children: [
          /* @__PURE__ */ jsx("h3", { className: "concierge-section-title", children: section.title }),
          section.description && /* @__PURE__ */ jsx("p", { className: "concierge-section-description", children: section.description }),
          /* @__PURE__ */ jsx(ProductGroupCarousel, { products, allStacklineSkus: sectionSkus })
        ]
      }
    )
  ] });
}
export {
  DataProductCarouselsPart
};
//# sourceMappingURL=DataProductCarouselsPart.js.map
